import { LucideProps } from "lucide-react"

export const Icons = {
  promoRibbon: (props: LucideProps) => (
    <svg
      width="52"
      height="20"
      viewBox="0 0 52 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 20L0 16H4V20Z" fill="#057E2E" />
      <path
        d="M0 6C0 3.79086 1.79086 2 4 2H50.0681C50.8793 2 51.3529 2.91504 50.8846 3.57737L47.8666 7.84526C47.3772 8.53731 47.3772 9.46269 47.8666 10.1547L50.8846 14.4226C51.3529 15.085 50.8793 16 50.0681 16H0V6Z"
        fill="#26AA53"
      />
      <path
        d="M6.39831 12V5.5H9.29661C10.839 5.5 11.3814 6.70339 11.3814 7.74576C11.3814 8.77966 10.839 9.90678 9.29661 9.90678H7.65254V12H6.39831ZM7.65254 8.86441H9.09322C9.61864 8.86441 10.2458 8.61864 10.2458 7.74576C10.2458 6.86441 9.61017 6.60169 9.09322 6.60169H7.65254V8.86441ZM12.8526 12V5.5H15.7933C17.3357 5.5 17.8865 6.64407 17.8865 7.60169C17.8865 8.3983 17.4967 9.29661 16.4034 9.5L18.0814 12H16.734L15.1407 9.61864H14.1068V12H12.8526ZM14.1068 8.57627H15.6577C16.1831 8.57627 16.7255 8.33898 16.7255 7.60169C16.7255 6.86441 16.1746 6.61017 15.6577 6.61017H14.1068V8.57627ZM22.6667 12.1356C20.565 12.1356 19.226 10.5763 19.226 8.72881C19.226 6.8983 20.565 5.33898 22.6667 5.33898C24.7769 5.33898 26.1159 6.8983 26.1159 8.72881C26.1159 10.5763 24.7769 12.1356 22.6667 12.1356ZM22.6667 10.9068C23.9548 10.9068 24.7853 9.92373 24.7853 8.72881C24.7853 7.55085 23.9548 6.5678 22.6667 6.5678C21.3786 6.5678 20.5565 7.54237 20.5565 8.72881C20.5565 9.9322 21.387 10.9068 22.6667 10.9068ZM27.6069 12V5.5H29.2425L31.073 9.94915L32.912 5.5H34.5391V12H33.2679V7.83898L31.5476 12H30.5984L28.8866 7.83898V12H27.6069ZM39.5108 12.1356C37.4092 12.1356 36.0702 10.5763 36.0702 8.72881C36.0702 6.8983 37.4092 5.33898 39.5108 5.33898C41.621 5.33898 42.96 6.8983 42.96 8.72881C42.96 10.5763 41.621 12.1356 39.5108 12.1356ZM39.5108 10.9068C40.799 10.9068 41.6295 9.92373 41.6295 8.72881C41.6295 7.55085 40.799 6.5678 39.5108 6.5678C38.2227 6.5678 37.4007 7.54237 37.4007 8.72881C37.4007 9.9322 38.2312 10.9068 39.5108 10.9068Z"
        fill="white"
      />
    </svg>
  ),
  emptyCart: (props: LucideProps) => {
    return (
      <svg
        width="160"
        height="151"
        viewBox="0 0 160 151"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="80" cy="65.0605" r="52" fill="#F1F1F1" />
        <rect
          x="59.8617"
          y="64.2849"
          width="50.3636"
          height="70.7273"
          rx="7"
          transform="rotate(2.5 59.8617 64.2849)"
          fill="#EEEEEE"
          stroke="#C4C4C4"
          strokeWidth="2"
        />
        <rect
          x="29.0294"
          y="59.5024"
          width="54.3636"
          height="74.7273"
          rx="9"
          transform="rotate(-7.5 29.0294 59.5024)"
          fill="#FAFAFA"
          stroke="#C4C4C4"
          strokeWidth="2"
        />
        <path
          d="M31.1956 68.2948C30.6189 63.9144 33.7024 59.8958 38.0829 59.3191L74.1355 54.5727C78.5159 53.996 82.5345 57.0795 83.1112 61.46L84.2504 70.1126L32.3347 76.9474L31.1956 68.2948Z"
          fill="#EEEEEE"
        />
        <rect
          x="93.3574"
          y="55.71"
          width="2.18182"
          height="7.27273"
          rx="1.09091"
          transform="rotate(82.5 93.3574 55.71)"
          fill="#999999"
        />
        <rect
          x="73.4326"
          y="43.6621"
          width="2.18182"
          height="7.27273"
          rx="1.09091"
          transform="rotate(-7.5 73.4326 43.6621)"
          fill="#999999"
        />
        <rect
          x="86.2168"
          y="45.6475"
          width="2.18182"
          height="7.27273"
          rx="1.09091"
          transform="rotate(37.5 86.2168 45.6475)"
          fill="#999999"
        />
        <rect
          x="37.7617"
          y="79.168"
          width="42.1818"
          height="2.90909"
          rx="1.45455"
          transform="rotate(-7.5 37.7617 79.168)"
          fill="#DCDCDC"
        />
        <rect
          x="39.6602"
          y="93.5889"
          width="42.1818"
          height="2.90909"
          rx="1.45455"
          transform="rotate(-7.5 39.6602 93.5889)"
          fill="#DCDCDC"
        />
        <rect
          x="41.5586"
          y="108.009"
          width="42.1818"
          height="2.90909"
          rx="1.45455"
          transform="rotate(-7.5 41.5586 108.009)"
          fill="#DCDCDC"
        />
        <rect
          x="38.5215"
          y="84.9355"
          width="15.2727"
          height="2.90909"
          rx="1.45455"
          transform="rotate(-7.5 38.5215 84.9355)"
          fill="#EEEEEE"
        />
        <rect
          x="40.4199"
          y="99.3564"
          width="15.2727"
          height="2.90909"
          rx="1.45455"
          transform="rotate(-7.5 40.4199 99.3564)"
          fill="#EEEEEE"
        />
        <rect
          x="42.3184"
          y="113.778"
          width="15.2727"
          height="2.90909"
          rx="1.45455"
          transform="rotate(-7.5 42.3184 113.778)"
          fill="#EEEEEE"
        />
      </svg>
    )
  },
  cart: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.41665 21.9999C8.56724 21.9999 9.49998 21.0672 9.49998 19.9166C9.49998 18.766 8.56724 17.8333 7.41665 17.8333C6.26605 17.8333 5.33331 18.766 5.33331 19.9166C5.33331 21.0672 6.26605 21.9999 7.41665 21.9999Z"
          fill="currentColor"
        />
        <path
          d="M18.25 21.9999C19.4006 21.9999 20.3334 21.0672 20.3334 19.9166C20.3334 18.766 19.4006 17.8333 18.25 17.8333C17.0994 17.8333 16.1667 18.766 16.1667 19.9166C16.1667 21.0672 17.0994 21.9999 18.25 21.9999Z"
          fill="currentColor"
        />
        <path
          d="M18.6667 16.1667H7C6.5825 16.1667 6.22917 15.8575 6.17417 15.4433L4.60417 3.66667H2V2H5.33333C5.75083 2 6.10417 2.30917 6.15917 2.72333L6.61833 6.16667H21.1667C21.43 6.16667 21.6783 6.29083 21.835 6.5025C21.9925 6.71417 22.0408 6.9875 21.965 7.23917L19.465 15.5725C19.3592 15.925 19.0342 16.1667 18.6667 16.1667Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  mapPin: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.8261 2C8 2 4 4.95652 4 9.82609C4 14.4348 10.9565 21.4783 11.2174 21.7391C11.3913 21.913 11.5652 22 11.8261 22C12.087 22 12.2609 21.913 12.4348 21.7391C12.6957 21.4783 19.6522 14.4348 19.6522 9.82609C19.6522 4.95652 15.6522 2 11.8261 2ZM11.8261 12.4348C10.3478 12.4348 9.21739 11.3043 9.21739 9.82609C9.21739 8.34783 10.3478 7.21739 11.8261 7.21739C13.3043 7.21739 14.4348 8.34783 14.4348 9.82609C14.4348 11.3043 13.3043 12.4348 11.8261 12.4348Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  note: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.3313 21.995H3.83313C3.61217 21.995 3.40026 21.9073 3.24402 21.751C3.08778 21.5948 3 21.3829 3 21.1619V2.83313C3 2.61217 3.08778 2.40026 3.24402 2.24402C3.40026 2.08778 3.61217 2 3.83313 2H18.8294C19.0504 2 19.2623 2.08778 19.4185 2.24402C19.5748 2.40026 19.6625 2.61217 19.6625 2.83313V12.5H17.9963V3.66625H4.66625V20.3288H11.3313V21.995Z"
          fill="currentColor"
        />
        <path
          d="M13.8307 6.99878H7.16565V8.66503H13.8307V6.99878Z"
          fill="currentColor"
        />
        <path
          d="M13.8307 11.1643H7.16565V12.8306H13.8307V11.1643Z"
          fill="currentColor"
        />
        <path
          d="M11.3313 15.3301H7.16565V16.9963H11.3313V15.3301Z"
          fill="currentColor"
        />
        <path
          d="M15.4662 21.3989C15.5502 21.3709 15.6268 21.3234 15.6897 21.2612L20.8324 16.1184C21.0559 15.895 21.0559 15.5338 20.8324 15.3104L19.6896 14.1676C19.4662 13.9441 19.105 13.9441 18.8816 14.1676L13.7388 19.3103C13.676 19.3726 13.6291 19.4492 13.6006 19.5338L13 22L15.4662 21.3989Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  voucher: (props: LucideProps) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.1112 6.88889C14.4178 6.88889 14.6667 6.64 14.6667 6.33333V3.55556C14.6667 3.24889 14.4178 3 14.1112 3H1.88893C1.58226 3 1.33337 3.24889 1.33337 3.55556V6.33333C1.33337 6.64 1.58226 6.88889 1.88893 6.88889C2.52226 6.88889 3.00004 7.36667 3.00004 8C3.00004 8.63333 2.52226 9.11111 1.88893 9.11111C1.58226 9.11111 1.33337 9.36 1.33337 9.66667V12.4444C1.33337 12.7511 1.58226 13 1.88893 13H14.1112C14.4178 13 14.6667 12.7511 14.6667 12.4444V9.66667C14.6667 9.36 14.4178 9.11111 14.1112 9.11111C13.4778 9.11111 13 8.63333 13 8C13 7.36667 13.4778 6.88889 14.1112 6.88889ZM6.0556 5.22222C6.5156 5.22222 6.88893 5.59556 6.88893 6.05556C6.88893 6.51556 6.5156 6.88889 6.0556 6.88889C5.5956 6.88889 5.22226 6.51556 5.22226 6.05556C5.22226 5.59556 5.5956 5.22222 6.0556 5.22222ZM9.94449 10.7778C9.48449 10.7778 9.11115 10.4044 9.11115 9.94444C9.11115 9.48444 9.48449 9.11111 9.94449 9.11111C10.4045 9.11111 10.7778 9.48444 10.7778 9.94444C10.7778 10.4044 10.4045 10.7778 9.94449 10.7778ZM5.77782 11.0078L4.99226 10.2222L10.2223 4.99222L11.0078 5.77778L5.77782 11.0078Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  bePoint: (props: LucideProps) => {
    return (
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g filter="url(#filter0_d_14862_239171)">
          <circle
            cx="10"
            cy="9"
            r="8"
            fill="url(#paint0_linear_14862_239171)"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 16.84C14.3299 16.84 17.84 13.3299 17.84 9C17.84 4.67009 14.3299 1.16 10 1.16C5.67009 1.16 2.16 4.67009 2.16 9C2.16 13.3299 5.67009 16.84 10 16.84ZM10 17C14.4183 17 18 13.4183 18 9C18 4.58172 14.4183 1 10 1C5.58172 1 2 4.58172 2 9C2 13.4183 5.58172 17 10 17Z"
          fill="#F3C800"
        />
        <g filter="url(#filter1_i_14862_239171)">
          <ellipse
            cx="9.99993"
            cy="9.00005"
            rx="6.22222"
            ry="6.22222"
            fill="#FFD200"
          />
        </g>
        <g clipPath="url(#clip0_14862_239171)">
          <path
            d="M13.9354 9.29674C13.6913 8.34281 12.7923 7.63574 11.7208 7.63574C11.0224 7.63574 10.3982 7.93628 9.97888 8.40989C9.99431 8.42733 10.0111 8.44612 10.0266 8.4649C10.3085 8.80569 10.4515 9.23234 10.4515 9.66571V10.3352H12.7923H13.7839C13.8751 10.3352 13.9522 10.2708 13.9676 10.1849C13.9887 10.0655 13.9999 9.94209 13.9999 9.81597C14.0013 9.63753 13.9775 9.46311 13.9354 9.29674ZM10.6493 9.29674C10.8484 8.92376 11.2524 8.66615 11.7208 8.66615C12.1892 8.66615 12.5932 8.92242 12.7923 9.29674H10.6493Z"
            fill="#1A6CE5"
          />
          <path
            d="M9.48108 9.83203C9.48529 10.3607 9.68444 10.8437 10.0154 11.2193C9.68585 10.8437 9.48529 10.3607 9.48108 9.83203Z"
            fill="url(#paint1_linear_14862_239171)"
          />
          <path
            d="M12.6843 10.7297C12.6352 10.6827 12.5581 10.6787 12.5048 10.7189C12.2103 10.9416 11.805 11.0356 11.3814 10.9108C11.0672 10.8182 10.819 10.6022 10.6815 10.3298C10.5679 10.1058 10.5385 9.78109 10.5385 9.78109L10.5062 9.50605C10.4852 9.31955 10.4417 9.13574 10.3674 8.96267C10.2973 8.7963 10.2061 8.63932 10.0911 8.49576C10.0672 8.46624 10.0434 8.43807 10.0182 8.40989C9.60021 7.93628 8.97469 7.63574 8.27623 7.63574C7.83444 7.63574 7.4221 7.75649 7.07288 7.96445V9.81597V9.81732C7.07288 9.15855 7.65071 8.62993 8.34776 8.66884C8.96908 8.70372 9.45294 9.20148 9.47679 9.79585L9.47819 9.81732V9.81866C9.47819 9.82402 9.47819 9.82805 9.47819 9.83342C9.4824 10.362 9.68155 10.845 10.0125 11.2207C10.0139 11.2221 10.0154 11.2234 10.0168 11.2261C10.4347 11.6997 11.0602 12.0002 11.7587 12.0002C12.3295 12.0002 12.8498 11.8003 13.2496 11.4689C13.3085 11.4193 13.3099 11.3321 13.2552 11.2797L12.6843 10.7297Z"
            fill="url(#paint2_linear_14862_239171)"
          />
          <path
            d="M9.48104 9.83184C9.48104 9.82782 9.48104 9.82379 9.48104 9.82111C9.48104 9.85733 9.47824 9.89356 9.47403 9.92979C9.41372 10.5107 8.9018 10.9656 8.27768 10.9656C7.61429 10.9656 7.07573 10.4517 7.07573 9.81708V9.81574V7.96422V7.96288V7.95483V6.07513C7.07573 6.03354 7.04067 6 6.99719 6H6.07854C6.03506 6 6 6.03354 6 6.07513V9.78757V9.82648C6 9.85599 6.0014 9.88551 6.0028 9.91503C6.0028 9.91771 6.0028 9.92039 6.0028 9.92308C6.06592 11.0742 7.0617 11.9879 8.27909 11.9879C8.97473 11.9879 9.59745 11.6887 10.0154 11.2191C9.68441 10.8435 9.48525 10.3605 9.48104 9.83184Z"
            fill="url(#paint3_linear_14862_239171)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_14862_239171"
            x="0.857143"
            y="0.314286"
            width="18.2857"
            height="18.2857"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.457143" />
            <feGaussianBlur stdDeviation="0.571429" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_14862_239171"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_14862_239171"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_i_14862_239171"
            x="3.77771"
            y="2.77783"
            width="12.4445"
            height="12.6443"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.2" />
            <feGaussianBlur stdDeviation="0.571429" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_14862_239171"
            />
          </filter>
          <linearGradient
            id="paint0_linear_14862_239171"
            x1="3.06667"
            y1="0.199999"
            x2="17.4667"
            y2="17"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD200" />
            <stop offset="0.369798" stopColor="#FFF9DB" />
            <stop offset="0.705224" stopColor="#FFE03F" />
            <stop offset="0.885432" stopColor="#FFF299" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_14862_239171"
            x1="4.77709"
            y1="10.526"
            x2="13.3575"
            y2="10.526"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.1117" stopColor="#00387C" />
            <stop offset="0.1483" stopColor="#013B80" />
            <stop offset="0.5386" stopColor="#0C5CA4" />
            <stop offset="0.7463" stopColor="#1068B2" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_14862_239171"
            x1="13.2971"
            y1="9.81682"
            x2="7.07481"
            y2="9.81682"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1A6CE5" />
            <stop offset="0.2171" stopColor="#1A69E0" />
            <stop offset="0.4585" stopColor="#1961D3" />
            <stop offset="0.7115" stopColor="#1853BD" />
            <stop offset="0.9711" stopColor="#163F9E" />
            <stop offset="1" stopColor="#163D9A" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_14862_239171"
            x1="5.87007"
            y1="9.20516"
            x2="9.57987"
            y2="8.59094"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1A6CE5" />
            <stop offset="0.2955" stopColor="#1A68E2" />
            <stop offset="0.5624" stopColor="#195DD7" />
            <stop offset="0.8175" stopColor="#194BC6" />
            <stop offset="1" stopColor="#1839B5" />
          </linearGradient>
          <clipPath id="clip0_14862_239171">
            <rect
              width="8"
              height="6"
              fill="white"
              transform="translate(6 6)"
            />
          </clipPath>
        </defs>
      </svg>
    )
  },
}
